import { Image7 } from "./image7";
import React from "react";

export const Gallery7 = (props) => {
  return (
    <div id="Youtube_thumbnails" className="text-center">
      <div className="container">
        <div className="section-title">
        <h2>Create a unique YouTube thumbnail for your videos!</h2>
        <p>
          Successful YouTubers use custom thumbnails to make their videos stand out, attract more clicks, and ultimately get more views and revenue. Eye-catching thumbnails set their content apart, even from more popular videos, enhancing their overall success.
          </p>
          <br></br><br></br>
          <h1>Photo Manipulation Random Thumbnail</h1>
          <p>Searching for a Photoshop maestro with a wealth of creative experience? Your quest ends here! I specialize in transforming ideas into visual wonders through expert photo editing and image manipulation. With a proven track record, I'm dedicated to crafting a personalized, immersive experience. Your vision is my guide; I navigate Photoshop's realms to bring your unique concepts to life. Seamless image merging, nuanced enhancements, and intricate edits are my forte. Let's collaborate to turn your ideas into extraordinary realities. Elevate your visual storytelling with my precision and commitment. The journey to awe-inspiring Photoshop edits starts now!</p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title7}-${i}`}
                    className="col-sm-6 col-md-3 col-lg-4"
                  >
                    <Image7
                      title7={d.title7}
                      largeImage7={d.largeImage7}
                      smallImage7={d.smallImage7}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
    
  );
};

